import { render, staticRenderFns } from "./eb-image.vue?vue&type=template&id=a55a3a86&"
import script from "./eb-image.vue?vue&type=script&lang=js&"
export * from "./eb-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports